import styled from 'styled-components'

const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99999;
  width: 100%;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
`
const Container = styled.div`
  background-color: #fff;
  width: calc(100% - 20px);
  max-width: 500px;
  p {
    margin-bottom: 5px;
  }
`
const Main = styled.main`
  padding: 20px;
`
const Header = styled.header`
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 0px 20px;
`
const CloseButton = styled.button`
  background-color: #fff;
  color: var(--dark-blue);
  font-size: 20px;
  font-weight: bold;
  width: 40px;
  height: 40px;
  margin: -10px;
  border-radius: 20px;
  transition: all 0.3s;
  &:hover {
    color: #fff;
    background-color: var(--orange);
  }
`
const Title = styled.h1`
  font-weight: bold;
  color: var(--orange);
  font-size: 24px;
  line-height: 110%;
`

export { Overlay, Title, Container, Main, Header, CloseButton }
